import { Theme } from '@mui/material';

const Typography = (theme: Theme) => ({
  fontFamily: `"Noto Sans", sans-serif`,
  h6: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: '130%',
  },
  h5: {
    fontSize: '1.5rem',
    color: theme.palette.text.primary,
    fontWeight: 600,
    lineHeight: '130%',
  },
  h4: {
    fontSize: '2.125rem',
    color: theme.palette.text.primary,
    fontWeight: 700,
    lineHeight: '123%',
  },
  h3: {
    fontSize: '3rem',
    color: theme.palette.text.primary,
    fontWeight: 700,
    lineHeight: '116%',
  },
  h2: {
    fontSize: '3.75rem',
    color: theme.palette.text.primary,
    fontWeight: 700,
    lineHeight: '120%',
  },
  h1: {
    fontSize: '6rem',
    color: theme.palette.text.primary,
    fontWeight: 700,
    lineHeight: '116.7%',
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    lineHeight: '150%',
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    lineHeight: '150%',
  },
  caption: {
    fontSize: '0.75rem',
    color: theme.palette.text.primary,
    fontWeight: 400,
    lineHeight: '150%',
  },
  caption2: {
    fontSize: '0.75rem',
    color: theme.palette.text.primary,
    fontWeight: 400,
    lineHeight: '100%',
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: '150%',
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: '143%',
  },
});

export default Typography;
